import { useEffect, useRef } from 'react'
import { noteTakerStore } from 'shared/stores/noteTakerStore'
import { createTranscriptProvider } from '../providers/createTranscriptProvider'

export function useNoteTakerTranscript() {
	const providerRef = useRef(null)

	useEffect(() => {
		const provider = createTranscriptProvider({ store: noteTakerStore })
		providerRef.current = provider
		noteTakerStore.registerTranscriptProvider(provider)

		return () => {
			provider.dispose?.()
			providerRef.current = null
			noteTakerStore.registerTranscriptProvider(null)
		}
	}, [])

	useEffect(() => {
		if (process.env.REACT_APP_NOTE_TAKER_MOCK_TRANSCRIPT !== 'true') return
		if (!noteTakerStore.isRecording) return
		providerRef.current?.sync?.(noteTakerStore.recordingSeconds)
	}, [])
}
